import { connect } from 'react-redux'
import Sidebar from '../../../../common/containers/Sidebar'
import Card from '../../../../common/containers/Card'
import { Route, Routes } from 'react-router'
import { useState } from 'react'
import LocationCategoryList from './LocationCategoryList'
import LocationCategoryEdit from './LocationCategoryEdit'

let LocationCategoryPage = () => {
    const [pageAttr, setPageAttr] = useState({})
    return (
        <Sidebar>
            <Card {...pageAttr}>
                <Routes>
                    <Route path='/edit/:id' element={<LocationCategoryEdit setPageAttr={setPageAttr} />} />
                    <Route path='/add' element={<LocationCategoryEdit setPageAttr={setPageAttr} />} />
                    <Route path='/' element={<LocationCategoryList setPageAttr={setPageAttr} />} />
                </Routes>
            </Card>
        </Sidebar>
    )
}

export default connect()(LocationCategoryPage)